/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-center-enter.vue?vue&type=template&id=7f338c5e&scoped=true&"
import script from "./task-center-enter.vue?vue&type=script&lang=ts&"
export * from "./task-center-enter.vue?vue&type=script&lang=ts&"
import style0 from "./task-center-enter.vue?vue&type=style&index=0&id=7f338c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f338c5e",
  null
  
)

export default component.exports